/* eslint-disable react/no-array-index-key */
/* eslint-disable react/no-unescaped-entities */
import React, { useState } from 'react';
import { TradingKeywordTypes, TradingMessageTypes } from 'store/modules/monitoring_store/types';
import moment from 'moment';
import { Container } from './styles';

interface ChatMessageSearchProps {
  setShowSearchMessage: React.Dispatch<React.SetStateAction<boolean>>;
  keywords: Array<TradingKeywordTypes>;
  setMessageSearch: React.Dispatch<React.SetStateAction<string>>;
  setScrollTargetMessageId: React.Dispatch<React.SetStateAction<number | null>>;
  searchResults: TradingMessageTypes[];
}

const ChatMessageSearch = ({
  setShowSearchMessage,
  keywords,
  setMessageSearch,
  setScrollTargetMessageId,
  searchResults,
}: ChatMessageSearchProps) => {
  const [localSearch, setLocalSearch] = useState('');

  return (
    <Container className="p-3">
      <div className="search-header d-flex align-items-center justify-content-between pb-3">
        <div className="d-flex align-items-center">
          <button type="button" className="close" onClick={() => setShowSearchMessage(false)}>
            <span>&times;</span>
          </button>

          <h6 className="font-weight-bold mb-0 text-dark">Pesquisar mensagens</h6>
        </div>

        <div className="btn-group">
          <button type="button" className="btn btn-link dropdown-toggle p-0" data-toggle="dropdown">
            Palavras-chaves
          </button>

          <div className="dropdown-menu">
            {keywords?.length > 0 ? (
              keywords.map((keyword, index) => (
                <button
                  key={`${keyword}-${index}`}
                  className="dropdown-item"
                  type="button"
                  onClick={() => {
                    setLocalSearch(keyword?.keyword);
                    setMessageSearch(keyword?.keyword);
                  }}
                >
                  {keyword?.keyword}
                </button>
              ))
            ) : (
              <span className="dropdown-item text-muted">Nenhuma palavra-chave</span>
            )}
          </div>
        </div>
      </div>
      <div className="search-body">
        <div className="d-flex align-items-center">
          <input
            type="text"
            className="form-control"
            placeholder="Buscar mensagem"
            value={localSearch}
            onChange={(e) => {
              const { value } = e.target;
              setLocalSearch(value);
              setMessageSearch(value);
            }}
          />
          <button
            type="button"
            className="btn btn-link ml-2 p-0"
            onClick={() => {
              setMessageSearch('');
              setLocalSearch('');
            }}
          >
            Limpar
          </button>
        </div>

        <hr className="mt-3 mb-0" />
        {searchResults.length > 0 && (
          <div className="search-results">
            {searchResults.map((msg) => (
              <button
                key={msg?.id}
                type="button"
                className="search-result-item w-100 text-left p-3 border-bottom border-0 btn-outline-light"
                onClick={() => setScrollTargetMessageId(msg?.id)}
              >
                <p className="monitoring-date d-block mb-1 text-dark">
                  {moment(msg?.message_time).format('DD/MM/YYYY | k:mm')}
                </p>

                <span className="text-muted d-block my-1">{msg?.message_holder}</span>

                <div className="text-truncate text-dark">{msg?.message_highlight}</div>
              </button>
            ))}
          </div>
        )}
      </div>
    </Container>
  );
};

export default ChatMessageSearch;
